import { render, staticRenderFns } from "./contact-path.vue?vue&type=template&id=0f92a56c&scoped=true&lang=html"
import script from "./contact-path.vue?vue&type=script&lang=js"
export * from "./contact-path.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f92a56c",
  null
  
)

export default component.exports